import { Typography } from '@mui/material'
import * as S from './ReplacementMainPage.styles'
import { useHistory } from 'react-router-dom'

export const ReplacementMainPage: React.FC = () => {
  const history = useHistory()

  return (
    <S.Wrapper>
      <S.TitleContainer>
        <Typography variant='h6' fontWeight='bold'>Reposição</Typography>
      </S.TitleContainer>
      <S.SubtitleContainer>
        <Typography variant='h6' fontWeight='bold'>Selecione o tipo de reposição que você deseja iniciar:</Typography>
      </S.SubtitleContainer>
      <S.ButtonsContainer>
        <S.CustomButton
          title='Iniciar Reposição Ronda'
          type='button'
          bgColor='lightBlue3'
          hoverColor='darkBlueHover2'
          letterColor='white'
          data-testid='replacement-button'
          onClick={() => history.push('replacement')}
        />
        <S.CustomButton
          title='Iniciar Movimentação PK'
          type='button'
          bgColor='lightBlue3'
          hoverColor='darkBlueHover2'
          letterColor='white'
          data-testid='pk-movement-button'
          onClick={() => history.push('pk-movement')}
        />
      </S.ButtonsContainer>
    </S.Wrapper>
  )
}
